import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './Home';
import About from './About';
import Blog from './blog';
import Timeline from './Timeline';
import Portfolio from './portfolio';
import MeetingRequestForm from './RequestMeeting';
import NewsDetails from './blogDetails';
import PersonalInjury from './practic_area/PersonalInjury';
import BusinessLaw from './practic_area/BusinessLaw';
import RouteLoader from './components/RouterLoader';

import Contact from './contact';
import Videos from './Videos';
import { useMediaQuery } from 'react-responsive';
import NotFound from './NotFound';
import Figgers from './Figgers';
import ScrollToTop from './common/ScrollToTop';
import './App.css'
import BlogDetails from './blogDetails'


function App() {
    window.isLargScreen = useMediaQuery({ maxWidth: 1920 });
    window.isDesktop = useMediaQuery({ minWidth: 1224 });
    window.isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1224 });
    window.isMobile = useMediaQuery({ maxWidth: 767 });

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://cdn.userway.org/widget.js";
        script.async = true;
        script.setAttribute("data-account", "sMgcbujAR8");
        script.setAttribute("data-position", "bottom");


        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    let url = process.env.REACT_APP_API_URL;
    sessionStorage.setItem('server_api_url', url)


    return (
        <Router basename={process.env.REACT_APP_BASE_PATH || "/"}>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<About />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogDetails />} />
                <Route path="/timeline" element={<Timeline />} />
                <Route path="/meetingrequest" element={<MeetingRequestForm />} />
                <Route path="/news/:id" element={<NewsDetails />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/videos" element={<Videos />} />
                <Route path="/figgers" element={<Figgers />} />
                <Route path="/personal-injury" element={<PersonalInjury />} />
                <Route path="/business-law" element={<BusinessLaw />} />
                <Route path="/contact-us" element={<Contact />} />


                {/* Catch-all route for undefined paths */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
}

export default App;
